mutation updateWalletFundsAddress($id: String!, $tag: String!, $eth_address: String!, $address_resolved: String!, $network: String!) {
	updateWalletFundsAddress(id: $id, tag: $tag, eth_address: $eth_address, address_resolved: $address_resolved, network: $network)
}
